import styled from "styled-components";
import { Button } from "reactstrap";

export const FullWrap = styled.div`
    background-image: url("/images/home.jpg");
    height: 100vh;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media only screen and (max-width:767px){
        background-image: url("/images/physicians_small.png");
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background-size: 153% 100%; 
    }
`;
export const FormWrap = styled.div`
    box-shadow: 0 0.5rem 1rem rgba(220,195,197,0.75) !important;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    padding:20px;
    width:50%;
    margin:0 auto;
    border-radius: 10px; 
    @media  only screen and (max-width:991px){
        max-width: 500px;
        width:100%;
    }
    input{
        border: 1px solid #c0ccda;
        border-radius: 3px;
        background: #fff;
        margin-bottom: 20px;
        height: unset;
        padding: 10px 15px;
        &:focus{
            outline:none !important;
            box-shadow:unset;
            border-color:#c0ccda;
        }
    }
`;
export const Heading = styled.h3`
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 1.2;
    font-style: normal;
    color: rgba(74,74,74,1.00);
    margin-bottom: 30px;
    text-align:center;
    @media only screen and (max-width:400px){
        font-size:1.8rem;
    }
`;
export const LoginButton = styled(Button)`
    background: transparent;
    border: 1px solid rgba(0,0,0,.1);
    padding: .7rem 1.5rem;
    transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
    border-radius: 50rem;
    font-size: 1rem;
    color:#474f56;
    font-weight: 600;
    width: 60%;
    margin: 20px auto;
    &:hover{
        background-color:#8cc63f;
        color:#fff;
        border: 1px solid #8cc63f;
    }
    &:focus{
        outline:none;
        box-shadow: unset;
    }
    &:disabled{
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
        cursor: unset;
        opacity: 0.4;
    }
    @media only screen and (max-width:600px){
        width:100%;
    }
`;

export const SignButton = styled.a`
    background: transparent;
    transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
    border-radius: 50rem;
    font-size: 1rem;
    color:#474f56;
    font-weight: 600;
    border: none;
    height: unset;
    padding: 0;
    margin: 15px auto;
    display:block;
    cursor:pointer;
    text-align:center;
    text-decoration:underline !important;
    &:hover{
        color:#8cc63f !important;
    }
    &:focus{
        outline:none;
        box-shadow: unset;
    }
    @media only screen and (max-width:600px){
        width:100%;
    }
`;



// WEBPACK FOOTER //
// ./src/component/Userlogin/styles.js